/**
 * Created by razial on 17.09.2025.
 */

Placements.ENTRIES["extraBarForce"] = {
    throttled: true,

    type: Placements.FREE_FOCUS,
    priority: 7,
    filter: function () {
        return cleverapps.environment.isMainScene() && cleverapps.extraBar.anyIconWithForce() && !cleverapps.config.demoMode;
    },

    action: function () {
        cleverapps.extraBar.showAnyForce();
    }
};
